import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {BubbleList} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(BubbleList, {
        'className': 'bubble-list-demo-history',
        'items': this.get('items'),
        'roles': this.get('roles'),
        'hasMoreHistory': this.get('hasMoreHistory'),
        'loadingHistory': this.get('loadingHistory'),
        'ev-loadHistory': this.loadHistory,
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['historyLoading'] = function($super, scope) {
                        return (
                            _$ce(2, 'div', (
                                (scope.loadingHistory) ?
                                    _$ce(2, 'span', '正在拉取更早消息...', 16) :
                                    scope.hasMoreHistory ?
                                        _$ce(2, 'span', '滑到顶部自动加载更早消息', 16) :
                                        _$ce(2, 'span', '没有更多历史了', 16)
                            ), 2, 'bubble-list-demo-history-loading')
                        );
                    }),
                    (__$blocks['historyLoading'] = function($super, data) {
                        var block = $blocks['historyLoading'];
                        var callBlock = function() {
                            return _$blocks['historyLoading'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    });
};